import React, { useState } from 'react';
import ForgetPasswordForm from '../../authentication/ForgetPasswordForm';
import AuthCardLayout from '../../../layouts/AuthCardLayout';
import ContentSuccess from "../ContentSuccess";

const ForgetPassword = () => {
  const [showSucessMessage, setShowSucessMessage] = useState(false);
  const [email, setEmail] = useState("");

  const sucessMessageHandle = (status, email) => {
    setShowSucessMessage(status);
    setEmail(email);
  };
  return (
    <AuthCardLayout>
      {showSucessMessage ? (
        <>
          <ContentSuccess
            layout="card"
            titleTag="h3"
            title="Success"
            sub="Please check your email !"
            content={`A password reset link has been sent to ${email} `}
          />
        </>
      ) : (
        <>
          <h4 className="mb-0"> Forgot your password?</h4>
          <p className="mb-0">Enter your email and we'll send you a reset link.</p>
          <ForgetPasswordForm layout="card" sucessMessageHandle={sucessMessageHandle} />
        </>
      )}
    </AuthCardLayout>
  );
};

export default ForgetPassword;
